import React from 'react';
import {
  Flex,
} from 'web-styled';

import * as S from './styled';

const elementBaseStyle = {
  base: {
    color: '#495057',
    fontSize: '1rem',
    letterSpacing: '0.025em',
    '::placeholder': {
      color: '#c1c1c1',
    },
  },
  invalid: {
    color: '#c23d4b',
  },
};

export type InputProps = {
  flex: string,
  width?: string,
  spacing?: number,
  label?: string,
  color: string,
  form: any,
  field: any,
  margin?: string,
  className?: string,
  errorStyle?: any,
  Element: any,
};

const FormElementField = ({
  label,
  field,
  form: {
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  },
  flex,
  spacing = 10,
  width = '100%',
  margin = '0',
  color,
  Element,
  errorStyle,
  className,
}: InputProps) => {
  const error = (touched[field.name] && errors[field.name]);

  return (
    <Flex
      column
      width={width}
      spacing={spacing}
      flex={flex}
      margin={margin}
      className={className}
    >
      {label && (
        <S.Label
          htmlFor={`${field.name}-id`}
          color={color}
        >
          {label}
        </S.Label>
      )}
      <S.FormElementContainer
        hasError={error}
      >
        <Element
          className="card-element"
          onChange={(e) => {
            setFieldValue(field.name, e.complete);
          }}
          onBlur={() => {
            setFieldTouched(field.name);
          }}
          options={{
            style: elementBaseStyle,
          }}
        />
      </S.FormElementContainer>
      {error && (
        <S.Error style={errorStyle}>
          {error}
        </S.Error>
      )}
    </Flex>
  );
};

export default FormElementField;
